type T = (url: string) => void;

const f: T = (url) => {
    window.location.href = url;
};

export default f;
